// src/util/InputMoney.js
import React, {forwardRef, useRef, useState} from 'react';

const InputMoney = forwardRef(({initialValue = 0, onChange, nameClass = ''}, ref) => {
    const [value, setValue] = useState(initialValue ? (initialValue / 100).toString() : '');
    const oldValueRef = useRef(value);

    console.log('Initial Value: ', initialValue);

    const handleChange = (e) => {
        let newValue = e.target.value;
        const oldValue = oldValueRef.current;

        newValue = newValue.replace(',', '.');

        if (newValue === '') {
            onSuccessfulChange(newValue);
            return;
        }

        if (isSubstring(newValue, oldValue)) {
            onSuccessfulChange(newValue);
            return;
        }

        if (oldValue === '') {
            if (newValue === '.' || newValue === '0') {
                newValue = '0.';
            }
        }

        if (newValue && newValue && oldValue.startsWith('.') && newValue.startsWith('.')) {
            newValue = '0' + newValue; // or str2 = '0' + str2, depending on your preference
        }

        newValue = removeLeadingZeros(newValue);

        if (newValue === '0.00') {
            return;
        }

        const regex = /^\d+(\.\d{0,2})?$/;
        if (regex.test(newValue)) {
            if (parseFloat(newValue) > 999999.99) {
                return;
            }
            onSuccessfulChange(newValue);
        }
    };

    const isSubstring = (newString, oldString) => {
        if (oldString.length !== newString.length + 1) {
            return false;
        }

        for (let i = 0; i < oldString.length; i++) {
            const modifiedOldString = oldString.slice(0, i) + oldString.slice(i + 1);
            if (modifiedOldString === newString) {
                return true;
            }
        }

        return false;
    };

    const removeLeadingZeros = (input) => {
        if (input === '0') {
            return '0';
        }

        let i = 0;
        while (i < input.length - 1 && input[i] === '0' && input[i + 1] !== '.') {
            i++;
        }

        return input.substring(i);
    };

    const onSuccessfulChange = (newValue) => {
        oldValueRef.current = newValue;
        setValue(newValue);
        onChange(Math.round(parseFloat(newValue) * 100));
    };

    return (
        <input
            ref={ref}
            type="text"
            value={value}
            min={0}
            step="0.01"
            onChange={handleChange}
            style={{width: '4.5em'}}
            className={nameClass}
        />
    );
});

export default InputMoney;
